import { forwardRef } from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  wrapperClassName?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { className = "", icon, wrapperClassName = "", disabled = false, ...props },
    ref
  ) => {
    return (
      <div
        className={`relative flex items-center ${
          disabled ? "opacity-70" : ""
        } ${wrapperClassName}`}
      >
        {icon && (
          <div className="absolute left-3 text-[#706f6f] pointer-events-none">
            {icon}
          </div>
        )}
        <input
          ref={ref}
          className={`flex h-[44px] w-full rounded-[7px] border border-[#dbdbdb] bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[#706f6f] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#e07828] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
            icon ? "pl-10" : ""
          } ${className}`}
          disabled={disabled}
          {...props}
        />
      </div>
    );
  }
);

Input.displayName = "Input";
